import React, { useEffect, useState } from 'react';
import styles from './styles/FollowStats.module.css';
import { getFollowStatus, getFollowVisibility, followUser, unfollowUser } from '../../services/FollowerServices';
import { useNavigate } from "react-router-dom";

const FollowStats = ({ userIsAccountOwner, accountOwner, setAccountOwner }) => {

    const [isFollowing, setIsFollowing] = useState(false);
    const [isFollowLoading, setIsFollowLoading] = useState(false);
    const [followError, setFollowError] = useState("");
    // Whether the profile owner's follow lists are viewable by this visitor
    const [listsVisible, setListsVisible] = useState(userIsAccountOwner);
    const navigate = useNavigate(); // For clicking on follow list and viewing it

    useEffect(() => {
        if (!accountOwner?._id) return;

        // The owner can always view their own lists
        if (userIsAccountOwner) {
            setListsVisible(true);
            return;
        }

        getFollowStatus(accountOwner._id)
            .then((data) => setIsFollowing(data.isFollowing))
            .catch((error) => console.error('Error checking follow status:', error));

        // Private lists render as plain text instead of dead links
        getFollowVisibility(accountOwner._id)
            .then((data) => setListsVisible(data.isVisible))
            .catch(() => setListsVisible(false));
    }, [accountOwner?._id, userIsAccountOwner]);

    const handleClickFollow = async () => {
        try {
            setIsFollowLoading(true);
            setFollowError("");

            const data = isFollowing
                ? await unfollowUser(accountOwner._id)
                : await followUser(accountOwner._id);

            setIsFollowing(!isFollowing);
            setAccountOwner((prev) => ({ // Update the follow count instantly
                ...prev,
                followerCount: data.followerCount
            }));

        } catch (error) {
            console.error("Error updating follow status:", error);
            setFollowError(error.response?.data?.message || "Unable to update follow status.");
        } finally {
            setIsFollowLoading(false);
        }
    };

    const renderCount = (count, label, path) =>
        listsVisible ? (
            <span className={styles.followLink} onClick={() => navigate(path)}>
                {count || 0} {label}
            </span>
        ) : (
            <span className={styles.followStat}>
                {count || 0} {label}
            </span>
        );

    return (
        <div className={styles.followStats}>

            {!userIsAccountOwner && (
                <button
                    className={styles.followButton}
                    onClick={handleClickFollow}
                    disabled={isFollowLoading}
                >
                    {isFollowLoading
                        ? 'Loading...'
                        : isFollowing
                            ? 'Following'
                            : 'Follow'}
                </button>
            )}

            {renderCount(accountOwner.followerCount, "Followers", `/followers/${accountOwner._id}`)}
            {renderCount(accountOwner.followingCount, "Following", `/following/${accountOwner._id}`)}

            {followError && <span className={styles.followError}>{followError}</span>}

        </div>
    );
}

export default FollowStats;
